import { ZastoupeniEnum } from "../api";

export const keysOfZastoupeni = Object.keys(ZastoupeniEnum);

export const getZastoupeniCaption = (typ: string | ZastoupeniEnum): string => {
  switch (typ) {
    case ZastoupeniEnum.EXTERNI:
      return "Externí";
    case ZastoupeniEnum.INTERNI:
      return "Interní";
  }
};

export const getZastoupeniItems = (): {
  id: ZastoupeniEnum;
  name: string;
}[] => {
  return keysOfZastoupeni.map((t: ZastoupeniEnum) => ({
    id: t,
    name: getZastoupeniCaption(t),
  }));
};
